import { c as _c } from "react/compiler-runtime";
import { FaVideo } from "react-icons/fa";
import { cx } from "@/lib/tailwind-utils";
interface TelehealthBadgeProps {
  className?: string;
}

/** A virtual service: the patient joins by video, whichever location books it. */
export const TelehealthBadge = t0 => {
  const $ = _c(5);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cx("inline-flex items-center gap-1 px-2 py-0.5 text-tiny font-semibold uppercase tracking-wider", "text-status-info-text bg-status-info-bg rounded-full flex-shrink-0", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FaVideo className="h-3 w-3" aria-hidden={true} />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t1) {
    t3 = <span className={t1}>{t2}Telehealth</span>;
    $[3] = t1;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};